"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
/* eslint-disable react/self-closing-comp */
const react_1 = __importDefault(require("react"));
const Popup_module_scss_1 = __importDefault(require("./Popup.module.scss"));
function Popup(props) {
    return react_1.default.createElement("div", Object.assign({ className: Popup_module_scss_1.default['popup'] }, props));
}
exports.default = Popup;
